import { useQuery } from "utilities";

const useOrderDetailsQuery = (id) => {
  const { data, isLoading, isError, error } = useQuery("/order-list", id.id);
  const order = data?.[0] || null;

  return {
    order, // Single order object with products array
    loading: isLoading,
    error: isError ? error : null,
  };
};

export default useOrderDetailsQuery;